import { render, staticRenderFns } from "./CustomDeliveryPlanning.vue?vue&type=template&id=841c493a&scoped=true&"
import script from "./CustomDeliveryPlanning.vue?vue&type=script&lang=js&"
export * from "./CustomDeliveryPlanning.vue?vue&type=script&lang=js&"
import style0 from "./CustomDeliveryPlanning.vue?vue&type=style&index=0&id=841c493a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "841c493a",
  null
  
)

export default component.exports